import React from "react";
import { useState, useEffect, useCallback, useRef } from "react";
import {
  currencyFormate,
  formatInputToCapitalization,
  getVoucherDate,
  removeCurrencyComma,
} from "../Date_Formate_Utilitiy/Index";
import { flushSync } from "react-dom";
import { useDispatch, useSelector } from "react-redux";
import { openModal, closeModal } from "../../redux/actions/action-creator";

export const useInputActionVoucher = ({
  data,
  setData,
  validations,
  refs,
  check_dropdown,
  inputRefs,
  dynamicInputRef,
  setNameInput,
  contra_account_ledger_list,
  itemData,
  itemLedgerData,
  dynamicInputRef_payment_allocation,
  setLastFocusedInput
}) => {
  const [submitConfirm, setSubmitConfirm] = useState("");
  const dispatch = useDispatch();
  const { godown_data = null, company_session } = useSelector((state) => state.common);
  const modal_state = useSelector((state) => state.common.modal_state);
  const [checkValue, setCheckValue] = useState(false);
  const [getPrevValue, setgetPrevValue] = useState(0);

  const handleItemUpdate = (e, index, key, value) => {
    // Check if any modal is open and prevent updates
    const isAnyModalOpen = modal_state?.ledgerCreate ||
      modal_state?.godownCreateVoucher ||
      modal_state?.stockItemCreate ||
      modal_state?.period ||
      modal_state?.changeMode ||
      modal_state?.configure ||
      modal_state?.voucherTypeNameSelect ||
      modal_state?.dispatchDetails ||
      modal_state?.orderDetails ||
      modal_state?.otherVoucher;

    if (isAnyModalOpen) {
      e.preventDefault();
      return;
    }

    const cleanString = (str) =>
      str?.replace(/[^a-zA-Z0-9]/g, "")?.toLowerCase();
    if (key === `particular_ledger_pay_amount`) {
      setCheckValue(false);
    }
    switch (key) {
      case "first":
        const value_ = contra_account_ledger_list?.some((item) =>
          cleanString(item?.ledger_name)
            .toLowerCase()
            ?.includes(cleanString(value).toLowerCase())
        );
        if (value_) {
          setData((prevState) => ({
            ...prevState,
            data: prevState.data.map((item, i) => {
              if (i === index) {
                const updatedItem = { ...item, [key]: value };
                return updatedItem;
              }
              return item;
            }),
          }));
        }
        break;
      case "item_name":
        const value_item_name = itemData?.some((item) =>
          cleanString(item?.name)
            .toLowerCase()
            ?.includes(cleanString(value).toLowerCase())
        );
        if (value_item_name) {
          setData((prevState) => ({
            ...prevState,
            data_item: prevState.data_item.map((item, i) => {
              if (i === index) {
                const updatedItem = { ...item, [key]: value };
                return updatedItem;
              }
              return item;
            }),
          }));
        }
        break;
      case "ledger_account":
        const value_ledger_account = itemLedgerData?.some((item) =>
          cleanString(item?.ledger_name)
            .toLowerCase()
            ?.includes(cleanString(value).toLowerCase())
        );
        if (value_ledger_account) {
          setData((prevState) => ({
            ...prevState,
            sale_ledger_data: prevState.sale_ledger_data.map((item, i) => {
              if (i === index) {
                const updatedItem = { ...item, [key]: value };
                return updatedItem;
              }
              return item;
            }),
          }));
        }
        break;
      case "item_amt":
        const value_item_amt = /^[0-9,.\b]*$/.test(value) || value === "";
        if (value_item_amt) {
          setData((prevState) => ({
            ...prevState,
            data_item: prevState.data_item.map((item, i) => {
              if (i === index) {
                const updatedItem = { ...item, [key]: value };
                return updatedItem;
              }
              return item;
            }),
          }));
        }
        break;
      case "ledger_amount":
        const value_ledger_amount = /^[0-9,.\b]*$/.test(value) || value === "";
        if (value_ledger_amount) {
          setData((prevState) => ({
            ...prevState,
            sale_ledger_data: prevState.sale_ledger_data.map((item, i) => {
              if (i === index) {
                const updatedItem = { ...item, [key]: value };
                return updatedItem;
              }
              return item;
            }),
          }));
        }
        break;
      case "godown_location":
        const value_godown_location = godown_data?.some((item) =>
          cleanString(item?.name)
            .toLowerCase()
            ?.includes(cleanString(value).toLowerCase())
        );
        if (value_godown_location) {
          setData((prevState) => ({
            ...prevState,
            data_item: prevState.data_item.map((item, i) => {
              if (i === index) {
                const updatedItem = { ...item, [key]: value };
                return updatedItem;
              }
              return item;
            }),
          }));
        }
        break;
      case "per_unit":
        const value_per = data?.data_item[index]?.item_units?.some((item) =>
          cleanString(item?.name)
            .toLowerCase()
            ?.includes(cleanString(value).toLowerCase())
        );
        if (value_per) {
          setData((prevState) => ({
            ...prevState,
            data_item: prevState.data_item.map((item, i) => {
              if (i === index) {
                const updatedItem = { ...item, [key]: value };
                return updatedItem;
              }
              return item;
            }),
          }));
        }
        break;
      case "item_qty":
        setData((prevState) => ({
          ...prevState,
          data_item: prevState.data_item.map((item, i) => {
            if (i === index) {
              const updatedItem = { ...item, [key]: value };
              return updatedItem;
            }
            return item;
          }),
        }));
        break;
      case "item_rate":
        const value_item_rate = /^[0-9,.\b]*$/.test(value) || value === "";
        if (value_item_rate) {
          setData((prevState) => ({
            ...prevState,
            data_item: prevState.data_item.map((item, i) => {
              if (i === index) {
                const updatedItem = { ...item, [key]: value };
                return updatedItem;
              }
              return item;
            }),
          }));
        }
        break;
      case "particular_ledger_pay_amount":
        if (/^[0-9,.\b]*$/.test(value) || value === "") {
          setData((prevState) => ({
            ...prevState,
            data: prevState.data.map((item, i) => {
              if (i === index) {
                const updatedItem = { ...item, [key]: value };
                return updatedItem;
              }
              return item;
            }),
          }));
        }
        break;
      case "payment_ledger_account":
        setData((prevState) => {
          const updatedState = {
            ...prevState,
            payment_allocation: prevState.payment_allocation.map((item, i) => {
              if (i === index) {
                const updatedItem = { ...item, [key]: value };
                return updatedItem;
              }
              return item;
            }),
          };

          // Calculate remaining amount before this allocation
          const remainingAmount = calculateRemainingAmount(updatedState);

          // If "Not Applicable" is selected, clear the payment_ledger_amount and update total_amount_allocate_party
          if (value === "Not Applicable") {
            updatedState.payment_allocation[index] = {
              ...updatedState.payment_allocation[index],
              payment_ledger_amount: ""
            };
            // Update total_amount_allocate_party to show remaining amount
            updatedState.total_amount_allocate_party = remainingAmount > 0 ? remainingAmount : 0;
          }
          // If this is the first payment allocation and no amount is set, populate with total amount
          else if (index === 0 && !updatedState.payment_allocation[index]?.payment_ledger_amount && updatedState.total_amount_item) {
            updatedState.payment_allocation[index] = {
              ...updatedState.payment_allocation[index],
              payment_ledger_amount: currencyFormate(updatedState.total_amount_item)
            };
          }
          // If this is not the first allocation and no amount is set, populate with remaining amount
          else if (index > 0 && !updatedState.payment_allocation[index]?.payment_ledger_amount && remainingAmount > 0) {
            updatedState.payment_allocation[index] = {
              ...updatedState.payment_allocation[index],
              payment_ledger_amount: currencyFormate(remainingAmount)
            };
          }

          return updatedState;
        });
        break;
      case "payment_ledger_amount":
        setData((prevState) => {
          const updatedState = {
            ...prevState,
            payment_allocation: prevState.payment_allocation.map((item, i) => {
              if (i === index) {
                const updatedItem = { ...item, [key]: value };
                return updatedItem;
              }
              return item;
            }),
          };

          // Calculate total allocated amount
          const totalAllocatedAmount = updatedState.payment_allocation.reduce((sum, item) => {
            const allocatedAmount = parseFloat(removeCurrencyComma(item?.payment_ledger_amount)) || 0;
            return sum + allocatedAmount;
          }, 0);

          // Update the total_allocated_amount in the state
          updatedState.total_allocated_amount = totalAllocatedAmount;

          // Calculate remaining amount and update total_amount_allocate_party
          const remainingAmount = (updatedState.total_amount_item || 0) - totalAllocatedAmount;
          updatedState.total_amount_allocate_party = remainingAmount > 0 ? remainingAmount : 0;

          // If there's remaining amount and we're not at the last row, populate the next row
          if (remainingAmount > 0 && index < updatedState.payment_allocation.length - 1) {
            // Find the next empty payment_ledger_amount field
            const nextIndex = index + 1;
            if (!updatedState.payment_allocation[nextIndex]?.payment_ledger_amount) {
              updatedState.payment_allocation[nextIndex] = {
                ...updatedState.payment_allocation[nextIndex],
                payment_ledger_amount: currencyFormate(remainingAmount) || "0.00"
              };
            }
          }

          return updatedState;
        });
        break;
    }

    if (e.key === "Enter") {
      e.preventDefault();
      handleDropdownDynamicClick(key, value, index);
    }
  };

  const handleDropdownDynamicClick = (key, value, index) => {

    // Handle Sales and Purchase voucher navigation
    if (isSalesOrPurchaseVoucher()) {
      handleSalesPurchaseNavigation(key, value, index);
      return;
    }

    // Handle other voucher types (Contra, Receipt, Payment)
    if (isOtherVoucherType() && value === "") {
      focusOnNarration();
      return;
    }

    // Fallback navigation for other fields
    handleFallbackNavigation(key, index);
  };

  // Helper function to check if voucher is Sales or Purchase
  const isSalesOrPurchaseVoucher = () => {
    return (
      data?.voucher_type_name === "Sales" ||
      data?.voucher_type_name === "Purchase" ||
      data?.voucher_type_name === "Credit Note" ||
      data?.voucher_type_name === "Debit Note"
    );
  };

  // Helper function to check if voucher is other type
  const isOtherVoucherType = () => {
    return (
      data?.voucher_type_name === "Contra" ||
      data?.voucher_type_name === "Receipt" ||
      data?.voucher_type_name === "Payment"
    );
  };

  // Helper function to focus on narration field
  const focusOnNarration = () => {
    if (inputRefs.narration?.current) {
      inputRefs.narration.current.setSelectionRange(
        0,
        inputRefs.narration.current.value?.length || 0
      );
      inputRefs.narration.current.focus();
    }
  };

  // Helper function to focus on dynamic field
  const focusOnDynamicField = (refs, fieldName, index) => {
    const fieldKey = `${fieldName}${index}`;
    const fieldRef = refs?.current?.[fieldKey];

    if (fieldRef) {
      fieldRef.focus();
      fieldRef.setSelectionRange(0, fieldRef.value?.length || 0);
    }
  };

  // Handle item rate calculations
  const handleItemRateCalculation = (value, index) => {
    const currentItem = data?.data_item[index];

    if (!currentItem?.is_unit_available) {
      return;
    }

    const qty = currentItem?.item_qty;
    const { numericValue, unit } = parseQuantityAndUnit(qty);

    setData((prevValueLoop) => {
      const updatedValueLoop = { ...prevValueLoop };
      const rate = parseFloat(removeCurrencyComma(value));
      const amount = rate * parseFloat(numericValue);

      updatedValueLoop.data_item[index] = {
        ...updatedValueLoop.data_item[index],
        item_qty: `${numericValue} ${unit}`,
        item_amt: amount ? currencyFormate(amount) : "",
        item_rate: rate ? currencyFormate(rate) : "",
      };

      return updatedValueLoop;
    });
  };

  // Parse quantity and unit from string
  const parseQuantityAndUnit = (qty) => {
    const regex = /^(\d+)\s*([a-zA-Z]+)?$/;
    const match = regex.exec(qty?.toLowerCase()?.trim());

    let numericValue, unit;

    if (match) {
      numericValue = match[1];
      const unitMappings = {
        n: "nos",
        no: "nos",
        b: "box",
        bo: "box",
        nos: "nos",
        box: "box",
      };
      unit = match[2] ? unitMappings[match[2]] || match[2] : "nos";
    } else {
      numericValue = qty?.replace(/[^\d]/g, "") || "";
      unit = "nos";
    }

    return { numericValue, unit };
  };

  // Handle Sales/Purchase voucher navigation
  const handleSalesPurchaseNavigation = (key, value, index) => {
    switch (key) {
      case "ledger_account":
        handleLedgerAccountNavigation(value, index);
        break;
      case "item_name":
        handleItemNameNavigation(value, index);
        break;
      case "godown_location":
        handleGodownLocationNavigation(index);
        break;
      case "item_qty":
        handleItemQtyNavigation(index);
        break;
      case "item_rate":
        handleItemRateCalculation(value, index);
        handleItemRateNavigation(index);
        break;
      case "per_unit":
        handlePerUnitNavigation(index);
        break;
      case "item_amt":
        handleItemAmtNavigation(value, index);
        break;
      case "ledger_amount":
        handleLedgerAmountNavigation(index);
        break;
      case "payment_ledger_account":
        handlePaymentLedgerAccountNavigation(value, index);
        break;
      case "payment_ledger_amount":
        handlePaymentLedgerAmountNavigation(index);
        break;
      default:
        break;
    }
  };

  // Handle ledger account navigation
  const handleLedgerAccountNavigation = (value, index) => {
    if (value === "") {
      focusOnDynamicField(dynamicInputRef_payment_allocation, "payment_ledger_account", 0);
    } else {
      focusOnDynamicField(dynamicInputRef, "ledger_amount", index);
    }
  };

  // Handle item name navigation
  const handleItemNameNavigation = (value, index) => {
    if (value === "") {
      // Open ledger section
      setData((prevState) => ({
        ...prevState,
        data_item: prevState.data_item.map((item, i) => ({
          ...item,
          check_open: i === index ? true : item.check_open,
        })),
      }));

      setTimeout(() => {
        focusOnDynamicField(dynamicInputRef, "ledger_account", 0);
      }, 0);
      return;
    }

    // Navigate to next field based on conditions
    const currentItem = data?.data_item[index];
    let nextField;

    if (data?.location === "Any") {
      nextField = `godown_location${index}`;
    } else if (currentItem?.is_unit_available) {
      nextField = `item_qty${index}`;
    } else {
      nextField = `item_amt${index}`;
    }

    focusOnDynamicField(dynamicInputRef, nextField.replace(`${index}`, ""), index);
  };

  // Handle godown location navigation
  const handleGodownLocationNavigation = (index) => {
    const currentItem = data?.data_item[index];
    const nextField = currentItem?.is_unit_available ? `item_qty${index}` : `item_amt${index}`;

    focusOnDynamicField(dynamicInputRef, nextField.replace(`${index}`, ""), index);
  };

  // Handle item quantity navigation
  const handleItemQtyNavigation = (index) => {
    const currentItem = data?.data_item[index];
    const itemQtyValue = currentItem?.item_qty;

    if (!itemQtyValue || itemQtyValue.trim() === "") {
      // If item_qty is empty, go to item_amt
      focusOnDynamicField(dynamicInputRef, "item_amt", index);
      return;
    }

    // Process quantity if unit is available
    if (currentItem?.is_unit_available) {
      processItemQuantity(index);
    }

    // Navigate to item_rate
    focusOnDynamicField(dynamicInputRef, "item_rate", index);
  };

  // Process item quantity calculations
  const processItemQuantity = (index) => {
    const qty = data?.data_item[index]?.item_qty;
    const { numericValue, unit } = parseQuantityAndUnit(qty);

    const currentItem = data?.data_item[index];
    const mainUnit = currentItem?.main_unit_name;
    const whereUnitNum = parseFloat(currentItem?.where_unit_num);
    const whereAlternateUnitNum = parseFloat(currentItem?.where_alternate_unit_num);

    const finalUnit = unit || mainUnit || "nos";
    const { totalNos, totalBox, combinationText } = calculateUnitConversion(
      numericValue,
      finalUnit,
      currentItem,
      whereUnitNum,
      whereAlternateUnitNum
    );

    setData((prevState) => ({
      ...prevState,
      data_item: prevState.data_item.map((item, i) => {
        if (i === index) {
          return {
            ...item,
            item_qty: `${numericValue} ${finalUnit}`,
            total_nos_box: totalBox.toFixed(2),
            total_no_box_unit: totalNos.toString(),
            combination_of_units: combinationText,
          };
        }
        return item;
      }),
    }));
  };

  // Calculate unit conversion
  const calculateUnitConversion = (numericValue, unit, currentItem, whereUnitNum, whereAlternateUnitNum) => {
    let totalNos = parseFloat(numericValue);
    let totalBox = 0;
    let combinationText = "";

    if (unit.toLowerCase() === currentItem?.item_alternate_unit?.toLowerCase()) {
      totalBox = parseFloat(numericValue);
      totalNos = totalBox * whereUnitNum;
      combinationText = `${totalBox} ${currentItem?.item_alternate_unit} = ${totalNos} ${currentItem?.main_unit_name}`;
    } else {
      totalBox = totalNos / whereAlternateUnitNum;
      combinationText = `${totalBox.toFixed(2)} ${currentItem?.item_alternate_unit}`;
    }

    return { totalNos, totalBox, combinationText };
  };

  // Handle item rate navigation
  const handleItemRateNavigation = (index) => {
    focusOnDynamicField(dynamicInputRef, "per_unit", index);
  };

  // Handle per unit navigation
  const handlePerUnitNavigation = (index) => {
    focusOnDynamicField(dynamicInputRef, "item_amt", index);
  };

  // Handle item amount navigation
  const handleItemAmtNavigation = (value, index) => {
    // Update the current item amount
    setData((prevState) => ({
      ...prevState,
      data_item: prevState.data_item.map((item, i) => {
        if (i === index) {
          return { ...item, item_amt: currencyFormate(value) };
        }
        return item;
      }),
    }));

    // Navigate to next row or add new row
    if (index < data?.data_item.length - 1) {
      focusOnDynamicField(dynamicInputRef, "item_name", index + 1);
    } else {
      addRow(index + 1);
      setTimeout(() => {
        focusOnDynamicField(dynamicInputRef, "item_name", index + 1);
      }, 0);
    }
  };

  // Handle ledger amount navigation
  const handleLedgerAmountNavigation = (index) => {
    if (index < data?.sale_ledger_data.length - 1) {
      focusOnDynamicField(dynamicInputRef, "ledger_account", index + 1);
    } else {
      addNewLedgerRow(index);
      setTimeout(() => {
        focusOnDynamicField(dynamicInputRef, "ledger_account", index + 1);
      }, 0);
    }
  };

  // Add new ledger row
  const addNewLedgerRow = (index) => {
    setData((prevFormData) => {
      const updatedFormData = { ...prevFormData };
      const newEntry = {
        id: `${(prevFormData.sale_ledger_data?.length || 0) + 1}`,
        ledger_account: "",
        ledger_account_id: "",
        ledger_amount: "",
        check: false,
      };
      updatedFormData.sale_ledger_data = [
        ...(updatedFormData.sale_ledger_data || []),
        newEntry,
      ];
      return updatedFormData;
    });
  };

  // Handle payment ledger account navigation
  const handlePaymentLedgerAccountNavigation = (value, index) => {
    if (value === "Not Applicable") {
      updateRemainingAmount();
      focusOnNarration();
      return;
    }

    focusOnDynamicField(dynamicInputRef_payment_allocation, "payment_ledger_amount", index);
  };

  // Update remaining amount
  const updateRemainingAmount = () => {
    const currentTotalAllocated = data?.payment_allocation?.reduce((sum, item) => {
      const allocatedAmount = parseFloat(removeCurrencyComma(item?.payment_ledger_amount)) || 0;
      return sum + allocatedAmount;
    }, 0) || 0;

    const remainingAmount = (data?.total_amount_item || 0) - currentTotalAllocated;

    setData((prevState) => ({
      ...prevState,
      total_amount_allocate_party: remainingAmount > 0 ? remainingAmount : 0,
    }));
  };

  // Handle payment ledger amount navigation
  const handlePaymentLedgerAmountNavigation = (index) => {
    const currentTotalAllocated = data?.payment_allocation?.reduce((sum, item) => {
      const allocatedAmount = parseFloat(removeCurrencyComma(item?.payment_ledger_amount)) || 0;
      return sum + allocatedAmount;
    }, 0) || 0;

    const remainingAmount = (data?.total_amount_item || 0) - currentTotalAllocated;

    if (remainingAmount <= 0) {
      focusOnNarration();
      return;
    }

    if (index < data?.payment_allocation.length - 1) {
      focusOnDynamicField(dynamicInputRef_payment_allocation, "payment_ledger_account", index + 1);
    } else {
      addNewPaymentAllocationRow(index, remainingAmount);
      setTimeout(() => {
        focusOnDynamicField(dynamicInputRef_payment_allocation, "payment_ledger_account", index + 1);
      }, 0);
    }
  };

  // Add new payment allocation row
  const addNewPaymentAllocationRow = (index, remainingAmount) => {
    setData((prevFormData) => {
      const updatedFormData = { ...prevFormData };
      const newEntry = {
        id: `${(prevFormData.payment_allocation?.length || 0) + 1}`,
        payment_ledger_account: "",
        payment_ledger_account_id: "",
        payment_ledger_amount: remainingAmount > 0 ? currencyFormate(remainingAmount) : "",
      };
      updatedFormData.payment_allocation = [
        ...(updatedFormData.payment_allocation || []),
        newEntry,
      ];
      return updatedFormData;
    });
  };

  // Handle fallback navigation
  const handleFallbackNavigation = (key, index) => {
    const fields = Object.keys(dynamicInputRef?.current);
    const currentIndex = fields.indexOf(`${key}${index}`);

    if (currentIndex < fields.length - 1) {
      const nextField = fields[currentIndex + 1];
      const nextRef = dynamicInputRef.current[nextField];
      if (nextRef) {
        nextRef.focus();
        nextRef.setSelectionRange(0, nextRef.value?.length || 0);
      }
    } else {
      addRow(index + 1);
      setTimeout(() => {
        const newRowRef = getNewRowRef(index);
        if (newRowRef) {
          newRowRef.focus();
          newRowRef.setSelectionRange(0, newRowRef.value?.length || 0);
        }
      }, 0);
    }
  };

  // Get new row reference based on voucher type
  const getNewRowRef = (index) => {
    if (isSalesOrPurchaseVoucher()) {
      const ledgerAmountRef = dynamicInputRef.current[`ledger_amount${index}`];
      if (ledgerAmountRef?.name === "ledger_amount") {
        return dynamicInputRef.current[`ledger_account${index + 1}`];
      }
      return dynamicInputRef.current[`item_name${index + 1}`];
    }
    return dynamicInputRef.current[`first${index + 1}`];
  };

  // Handle dynamic inputs
  const handleDynamicFocus = (e, index, field, value) => {
    // Check if any modal is open and prevent focus
    const isAnyModalOpen = modal_state?.ledgerCreate ||
      modal_state?.godownCreateVoucher ||
      modal_state?.stockItemCreate ||
      modal_state?.period ||
      modal_state?.changeMode ||
      modal_state?.configure ||
      modal_state?.voucherTypeNameSelect ||
      modal_state?.dispatchDetails ||
      modal_state?.orderDetails ||
      modal_state?.otherVoucher;

    if (isAnyModalOpen) {
      e.preventDefault();
      e.target.blur();
      return;
    }

    const refKey = `${field}${index}`;
    const ref = dynamicInputRef.current[refKey];
    if (ref) {
      setNameInput(ref);
      ref.setSelectionRange(0, ref.value?.length || 0);
    }
    if (field === "first") {
      dispatch(openModal(refKey));
    }
    if (field === "item_name") {
      dispatch(openModal(refKey));
    }
    if (field === "ledger_account") {
      dispatch(openModal(refKey));
    }
    if (field === "godown_location") {
      dispatch(openModal(refKey));
    }
    if (field === "per_unit") {
      dispatch(openModal(refKey));
    }

    if (field === `particular_ledger_pay_amount`) {
      if (value) {
        setgetPrevValue(data?.data[index]?.particular_ledger_pay_amount);
        setCheckValue(true);
      } else {
        setCheckValue(false);
      }
    }
    if (field === "payment_ledger_account") {
      dispatch(openModal(refKey));
    }
  };

  const handleDynamicBlur = (e, index, field, value) => {
    const refKey = `${field}${index}`;
    if (field === "particular_ledger_pay_amount") {

      const val = removeCurrencyComma(value);
      const intValue = parseFloat(val ? val : 0, 10);

      if (!checkValue) {

        const adjustment = data?.entry_name === "Payment" ? intValue : -intValue;
        const new_data = data?.data.filter((item) => {
          return (
            item.particular_ledger_id === data?.data[index].particular_ledger_id
          );
        });

        const get_amount = new_data.slice(-1).map((item, index) => {
          return item.particular_ledger_balance;
        });

        const curr = removeCurrencyComma(
          Array.isArray(get_amount) ? get_amount[0] : get_amount
        );

        const newParticularLedgerBalance = parseFloat(curr) + adjustment;

        setData((prevFormData) => {
          const updatedFormData = { ...prevFormData };
          updatedFormData.data = prevFormData.data.map((item, index1) => {
            if (
              item.particular_ledger_id ===
              prevFormData.data[index].particular_ledger_id
            ) {
              return {
                ...item,
                particular_ledger_balance:
                  currencyFormate(newParticularLedgerBalance) === null
                    ? 0
                    : currencyFormate(newParticularLedgerBalance),
              };
            }
            return item;
          });
          updatedFormData.data[index] = {
            ...updatedFormData.data[index],
            particular_ledger_pay_amount: currencyFormate(intValue),
          };
          return updatedFormData;
        });

        //-----------total---------------------

        // Only calculate totals for non-Sales/Purchase vouchers (Contra, Receipt, Payment)
        if (data?.voucher_type_name !== "Sales" && data?.voucher_type_name !== "Purchase") {
          ;

          if (data?.voucher_type_name === "Payment") {
            setData((prevData) => {
              // Calculate total amount using the updated data
              let new_total_amount = prevData?.data?.reduce((acc, item) => {
                let particular_ledger_pay_amount_value =
                  parseFloat(item?.particular_ledger_pay_amount?.replace(/\,/g, "")) || 0;
                return acc + particular_ledger_pay_amount_value;
              }, 0);

              return {
                ...prevData,
                account_ledger_balance:
                  parseFloat(prevData?.account_ledger_balance) - parseFloat(value),
                total_amount: new_total_amount,
              };
            });
          } else {
            setData((prevData) => {
              // Calculate total amount using the updated data
              let new_total_amount = prevData?.data?.reduce((acc, item) => {
                let particular_ledger_pay_amount_value =
                  parseFloat(item?.particular_ledger_pay_amount?.replace(/\,/g, "")) || 0;
                return acc + particular_ledger_pay_amount_value;
              }, 0);

              return {
                ...prevData,
                account_ledger_balance:
                  parseFloat(prevData?.account_ledger_balance) + parseFloat(value),
                total_amount: new_total_amount,
              };
            });
          }
        }
        ;
      } else {
      }
    }
    //-----------total end -----------------------------
    if (field === "first") {
      dispatch(closeModal(refKey));
    }
    if (field === "item_name") {
      dispatch(closeModal(refKey));
    }
    if (field === "ledger_account") {
      dispatch(closeModal(refKey));
    }
    if (field === "godown_location") {
      dispatch(closeModal(refKey));
    }
    if (field === "per_unit") {
      dispatch(closeModal(refKey));
    }
    if (field === "payment_ledger_account") {
      dispatch(closeModal(refKey));
    }
  };

  const handleKeyDownItem = (e, rowIndex, field) => {
    const fields = ["godown_name", "quantity", "rate", "per", "value"];
    const currentFieldIndex = fields.indexOf(field);
    if (e.key === "Tab" && e.shiftKey) {
      e.preventDefault();
      if (currentFieldIndex > 0) {
        const prevField = fields[currentFieldIndex - 1];
        dynamicInputRef.current[rowIndex]?.[prevField]?.focus();
      } else if (rowIndex > 0) {
        dynamicInputRef.current[rowIndex - 1]?.value?.focus();
      }
    }
  };

  const addRow = (nextIndex) => {
    // const totalAmount = data?.data_item.reduce((sum, item) => {
    //     return sum + (parseFloat(item.value) || 0);
    // }, 0);
    // const totalQuantity = data?.data_item.reduce((sum, item) => {
    //     return sum + (parseFloat(item.quantity) || 0);
    // }, 0);

    if (
      (data?.voucher_type_name === "Sales" &&
        data?.data_item.some((item) => item?.item_name === "")) ||
      (data?.voucher_type_name === "Purchase" &&
        data?.data_item.some((item) => item?.item_name === ""))
    ) {
      setData((prevFormData) => {
        const updatedFormData = { ...prevFormData };
        updatedFormData.sale_ledger_data = prevFormData.sale_ledger_data.map(
          (item, index) => {
            if (item?.ledger_account === "") {
              return { ...item, check: false };
            }
            return item;
          }
        );
        const newEntry_ledger = {
          id: `${(prevFormData.sale_ledger_data?.length || 0) + 1}`,
          ledger_account: "",
          ledger_account_id: "",
          ledger_amount: "",
          check: false,
        };
        updatedFormData.sale_ledger_data = [
          ...(updatedFormData.sale_ledger_data || []),
          newEntry_ledger,
        ];
        return updatedFormData;
      });
    } else if (
      data?.voucher_type_name === "Sales" ||
      data?.voucher_type_name === "Purchase"
    ) {
      setData((prevFormData) => {
        const updatedFormData = { ...prevFormData };
        updatedFormData.data_item = prevFormData.data_item.map(
          (item, index) => {
            if (item.item_id === prevFormData?.data[nextIndex - 1]?.item_id) {
              return {
                ...item,
              };
            }
            return item;
          }
        );
        const newEntry_item = {
          id: `${(prevFormData.data_item?.length || 0) + 1}`,
          item_name: "",
          item_id: "",
          godown_location: "",
          godown_location_id: "",
          item_qty: "",
          item_rate: "",
          per_unit: "",
          item_amt: "",
          item_alternate_unit: "",
          is_unit_available: "",
          where_unit_num: "",
          where_alternate_unit_num: "",
          main_unit_name: "",
          combination_of_units: "",
          check_open: false,
          total_nos_box: "",
          total_no_box_unit: "",
        };
        updatedFormData.data_item = [
          ...(updatedFormData.data_item || []),
          newEntry_item,
        ];
        return updatedFormData;
      });
    } else {
      setData((prevFormData) => {
        const updatedFormData = { ...prevFormData };
        updatedFormData.data = prevFormData.data.map((item, index) => {
          if (
            item.particular_ledger_id ===
            prevFormData?.data[nextIndex - 1]?.particular_ledger_id
          ) {
            return {
              ...item,
              //    particular_ledger_balance: currencyFormate(newParticularLedgerBalance),
            };
          }
          return item;
        });

        const newEntry = {
          id: `${(prevFormData.data?.length || 0) + 1}`,
          first: "",
          particular_ledger_balance: "",
          particular_ledger_id: "",
          particular_ledger_pay_amount: "",
        };
        // Add the new entry to the data array
        updatedFormData.data = [...(updatedFormData.data || []), newEntry];
        return updatedFormData;
      });
    }
    setTimeout(() => {
      // Focus on the appropriate field based on voucher type
      if (data?.voucher_type_name === "Sales" || data?.voucher_type_name === "Purchase") {
        const newRowRef = dynamicInputRef.current[`item_name${nextIndex}`];
        if (newRowRef) {
          newRowRef.focus();
          newRowRef.setSelectionRange(0, newRowRef.value?.length || 0);
        }
      } else {
        const newRowRef = dynamicInputRef.current[`first${nextIndex}`];
        if (newRowRef) {
          newRowRef.focus();
          newRowRef.setSelectionRange(0, newRowRef.value?.length || 0);
        }
      }
    }, 0);
  };

  const resetDynamicRefs = useCallback(() => {
    if (dynamicInputRef.current) {
      // Keep only the first row refs
      const firstRowRefs = {
        first0: dynamicInputRef.current.first0,
        particular_ledger_pay_amount0:
          dynamicInputRef.current.particular_ledger_pay_amount0,
      };
      dynamicInputRef.current = firstRowRefs;
    }
  }, [dynamicInputRef]);

  const handleChange = (e, index) => {
    // Check if any modal is open and prevent changes
    const isAnyModalOpen = modal_state?.ledgerCreate ||
      modal_state?.godownCreateVoucher ||
      modal_state?.stockItemCreate ||
      modal_state?.period ||
      modal_state?.changeMode ||
      modal_state?.configure ||
      modal_state?.voucherTypeNameSelect ||
      modal_state?.dispatchDetails ||
      modal_state?.orderDetails ||
      modal_state?.otherVoucher;

    if (isAnyModalOpen) {
      e.preventDefault();
      return;
    }

    const { name, value } = e.target;
    // Apply field-specific validations
    const validation = validations[name];
    if (validation) {
      const isValid = validation(value);
      if (isValid || value === "") {
        setData((prevData) => {
          const updatedData = { ...prevData };

          if (typeof index !== "number") {
            const updatedValue =
              name === "name" || name === "notes"
                ? formatInputToCapitalization(value)
                : value;
            updatedData[name] = updatedValue;
          } else if (typeof index === "number") {
            // Update array fields within `data_item`
            updatedData.data_item = updatedData.data_item.map((item, i) =>
              i === index ? { ...item, [name]: value } : item
            );
          }

          return updatedData;
        });
      }
    } else {
      flushSync(setData({ ...data, [name]: value }));
    }
  };

  const handleDropdownClick = (name, value) => {
    let nextField = null;
    const fields = Object.keys(inputRefs);
    const currentIndex = fields.indexOf(name);
    nextField = fields[currentIndex + 1] || null;
    if (name === 'dispatch_detail') {
      if (value === 'Available') {
        dispatch(openModal('dispatch_detail_modal'));
      }
      nextField = value === 'Available' ? 'delivery_note_no' : 'order_detail';
      setTimeout(() => {
        if (nextField && inputRefs[nextField]?.current) {
          inputRefs[nextField].current.focus();
          inputRefs[nextField].current.setSelectionRange(
            0,
            inputRefs[nextField].current.value.length
          );
        }
      }, 100);
    } else if (name === 'dispatch_date') {
      let check_value = ['delivery_note_no', 'dispatch_doc_no', 'dispatch_through', 'destination', 'carrier_name_agent', 'bill_of_loading', 'dispatch_date']
      const check_value_data = check_value.every((item) => data[item] === '')
      if (check_value_data) {
        setData((prevData) => ({
          ...prevData,
          dispatch_detail: 'Not Available',
        }));
      }
      dispatch(closeModal('dispatch_detail_modal'));
      nextField = 'order_detail';
      setTimeout(() => {
        if (nextField && inputRefs[nextField]?.current) {
          inputRefs[nextField].current.focus();
          inputRefs[nextField].current.setSelectionRange(
            0,
            inputRefs[nextField].current.value.length
          );
        }
      }, 100);
    } else

      // if (name === "order_detail") {
      //   const nextRef = dynamicInputRef.current["item_name0"];
      //   if (nextRef) {
      //     nextRef.focus();
      //     nextRef.setSelectionRange(0, nextRef.value?.length || 0);
      //   }
      // }

      if (name === "order_detail") {
        if (value === 'Available') {
          dispatch(openModal('order_detail_modal'));
          nextField = 'order_no'
          setTimeout(() => {
            if (nextField && inputRefs[nextField]?.current) {
              inputRefs[nextField].current.focus();
              inputRefs[nextField].current.setSelectionRange(
                0,
                inputRefs[nextField].current.value.length
              );
            }
          },);
        } else {
          const nextRef = dynamicInputRef.current["item_name0"];
          if (nextRef) {
            nextRef.focus();
            nextRef.setSelectionRange(0, nextRef.value?.length || 0);
          }
        }
      } else if (name === 'term_of_delivery') {
        let check_value = ['order_no', 'mode_term_payment', 'other_reference', 'term_of_delivery']
        const check_value_data = check_value.every((item) => data[item] === '')
        if (check_value_data) {
          setData((prevData) => ({
            ...prevData,
            order_detail: 'Not Available',
          }));
        }
        dispatch(closeModal('order_detail_modal'));
        setTimeout(() => {
          const nextRef = dynamicInputRef.current["item_name0"];
          if (nextRef) {
            nextRef.focus();
            nextRef.setSelectionRange(0, nextRef.value?.length || 0);
          }
        }, 50);
      }

      else if (name === "account") {
        const nextRef = dynamicInputRef.current["first0"];
        if (nextRef) {
          nextRef.focus();
          nextRef.setSelectionRange(0, nextRef.value?.length || 0);
        }
      } else if (nextField && inputRefs[nextField]?.current) {
        inputRefs[nextField].current.focus();
        inputRefs[nextField].current.setSelectionRange(
          0,
          inputRefs[nextField].current.value.length
        );
        setSubmitConfirm("");
      } else {
        setSubmitConfirm("Accept");
        inputRefs[name]?.current?.blur();
      }

    if (submitConfirm === "Accept") {
      resetDynamicRefs();
    }

  };

  const handleFocus = (e, index, field) => {
    // Check if any modal is open and prevent focus
    const isAnyModalOpen = modal_state?.ledgerCreate ||
      modal_state?.godownCreateVoucher ||
      modal_state?.stockItemCreate ||
      modal_state?.period ||
      modal_state?.changeMode ||
      modal_state?.configure ||
      modal_state?.voucherTypeNameSelect ||
      modal_state?.dispatchDetails ||
      modal_state?.orderDetails ||
      modal_state?.otherVoucher;

    if (isAnyModalOpen) {
      e.preventDefault();
      e.target.blur();
      return;
    }

    const { name } = e.target;
    const ref = inputRefs[name];
    if (ref) {
      setNameInput(ref);
      setLastFocusedInput && setLastFocusedInput(ref.current);
      ref?.current?.setSelectionRange(0, ref?.current?.value?.length);
    }
    const focusAction = refs[name]?.onFocus;
    if (focusAction) focusAction(index, field);
  };

  const handleBlur = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    const blurAction = refs[name]?.onBlur;

    if (blurAction) {
      flushSync(() => {
        blurAction(value, setData);
        if (name === 'create_date') {
          const dateResult = getVoucherDate(value, company_session);
          if (dateResult && dateResult.formattedDateString) {
            setData((prevData) => ({
              ...prevData,
              create_date: dateResult.formattedDateString,
              day_name: dateResult.day_show,
            }));
          }
        }
      });
    }
  };

  const handleKeyDown = (e) => {
    const { name, value } = e.target;
    if (e.key === "Space") {
      e.preventDefault();
      const cursorPosition = e.target.selectionStart;
      if (cursorPosition === 1) {
        setData({ ...data, [name]: "" });
        return;
      }
    }
    if (e.key === "Enter") {
      e.preventDefault();
      if (name === 'create_date' && value) {
        const dateResult = getVoucherDate(value, company_session);
        if (dateResult && dateResult.formattedDateString) {
          setData((prevData) => ({
            ...prevData,
            create_date: dateResult.formattedDateString,
            day_name: dateResult.day_show,
          }));
        }
      }
      handleDropdownClick(name, value);
      return;
    }
    if (e.shiftKey && e.key === "Tab") {
      setSubmitConfirm("");
      e.preventDefault();
      e.stopPropagation();
      const prevInputRef = refs[name]?.prev;
      if (prevInputRef && prevInputRef.current) {
        prevInputRef.current.focus();

        prevInputRef.current.setSelectionRange(
          0,
          prevInputRef?.current?.value?.length
        );
      }
      return;
    }
  };

  // Calculate total amounts for Sales and Purchase vouchers
  useEffect(() => {
    if (data?.voucher_type_name === "Sales" || data?.voucher_type_name === "Purchase") {
      // Calculate item total (from data_item)
      const itemTotal = data?.data_item?.reduce((sum, item) => {
        const itemAmount = parseFloat(removeCurrencyComma(item?.item_amt)) || 0;
        return sum + itemAmount;
      }, 0) || 0;

      // Calculate sales ledger total (from sale_ledger_data)
      const salesLedgerTotal = data?.sale_ledger_data?.reduce((sum, item) => {
        const ledgerAmount = parseFloat(removeCurrencyComma(item?.ledger_amount)) || 0;
        return sum + ledgerAmount;
      }, 0) || 0;

      // Calculate combined total (item total + sales ledger total)
      const combinedTotal = itemTotal + salesLedgerTotal;

      setData((prevState) => ({
        ...prevState,
        total_amount: itemTotal, // Keep item total in total_amount
        total_amount_item: combinedTotal, // Combined total in total_amount_item
        total_amount_allocate_party: combinedTotal,
      }));
    }
  }, [data?.data_item, data?.sale_ledger_data, data?.voucher_type_name]);

  // Calculate total allocated amount whenever payment_allocation changes
  useEffect(() => {
    if (data?.payment_allocation && (data?.voucher_type_name === "Sales" || data?.voucher_type_name === "Purchase")) {
      const totalAllocatedAmount = data.payment_allocation.reduce((sum, item) => {
        const allocatedAmount = parseFloat(removeCurrencyComma(item?.payment_ledger_amount)) || 0;
        return sum + allocatedAmount;
      }, 0);

      // Calculate remaining amount
      const remainingAmount = (data?.total_amount_item || 0) - totalAllocatedAmount;

      setData((prevState) => ({
        ...prevState,
        total_allocated_amount: totalAllocatedAmount,
        total_amount_allocate_party: remainingAmount > 0 ? remainingAmount : 0,
      }));
    }
  }, [data?.payment_allocation, data?.voucher_type_name, data?.total_amount_item]);

  // Helper function to calculate remaining amount
  const calculateRemainingAmount = (currentData) => {
    const totalAllocated = currentData?.payment_allocation?.reduce((sum, item) => {
      const allocatedAmount = parseFloat(removeCurrencyComma(item?.payment_ledger_amount)) || 0;
      return sum + allocatedAmount;
    }, 0) || 0;

    return (currentData?.total_amount_item || 0) - totalAllocated;
  };

  // Add cleanup effect
  useEffect(() => {
    return () => {
      if (dynamicInputRef.current) {
        dynamicInputRef.current = {};
      }
    };
  }, []);

  return {
    data,
    setData,
    handleChange,
    handleFocus,
    handleBlur,
    handleKeyDown,
    submitConfirm,
    setSubmitConfirm,
    handleItemUpdate,
    handleKeyDownItem,
    handleDynamicFocus,
    handleDynamicBlur,
    handleDropdownClick,
    handleDropdownDynamicClick,
    resetDynamicRefs,
  };
};
